module.exports = __webpack_public_path__ + "static/media/76_tn.b7bbc036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/76_tn.jpg
// module id = 561
// module chunks = 0